/* eslint no-throw-literal:0 */
/* global React:true,ReactDOM:true,OMFE:true,buildVersion:true */


/**
 * handleOutdatedBrowser - adds an 'outdated' message to the container
 *
 * @param  {type} appendTarget DOM Node
 * @return {type}              none
 */
function handleOutdatedBrowser(appendTarget) {
    const outdatedColor = '#f2b635';

    const target = appendTarget;
    target.innerHTML = `
        <div style="position: relative; height: 100%; width:100%; background-color: ${outdatedColor};">
            <table style="height: 100%; width: 100%;"><tr><td style="vertical-align:middle; text-align:center; color: #fff;">
                <h3 style="text-transform: uppercase;">Your Browser Is Out-of-Date!</h3>
                <p>Update your browser to view this website correctly. </p>
                <a href="http://outdatedbrowser.com/"
                    target="_blank"
                    style="display: block; border:1px solid #fff; width: 70%; margin: 0 auto; line-height: 30px; text-decoration: none; ` +
                    `color: #fff; text-transform: uppercase; font-size: 13px"
                    onMouseOver="javascript:this.style.backgroundColor='#fff';this.style.color='${outdatedColor}';"
                    onMouseOut="javascript:this.style.backgroundColor='';this.style.color='#fff';"
                >
                    Update my browser now
                </a>
            </td></tr></table>
        </div>
    `;
}

/**
 * load - Loads a specific ReactJS OMFEProduct
 *
 * @param  {string} OMFEComponent           name of component to load
 * @param  {DOMNode} container              container in which to load the component via ReactDOM.render
 * @param  {object} props = {}              default props to pass to OMFEComponent
 * @param  {array}  children                children to pass to OMFEComponent
 * @return {mixed}                          irrelevant return value
 */
let isBusy = false;
let pendingLoad = [];
export function load(OMFEComponent = undefined, container = undefined, props = {}, children) {
    // Busy State
    if (isBusy) {
        pendingLoad.push({ OMFEComponent, container, props, children });
        return false;
    }
    isBusy = true;

    // OMFE Components Configuration
    window.OMFECONFIG = window.OMFECONFIG || { };
    window.OMFECONFIG.distUrl = window.OMFECONFIG.distUrl || 'https://static.everymatrix.com/omc/p';
    const { distUrl } = window.OMFECONFIG;

    // Validate Component and appendTarget
    const Component = /^OMFE[A-Za-z0-9]+$/.test(OMFEComponent) && OMFEComponent || (() => { throw 'Invalid OMFEComponent supplied'; })() && false;
    const appendTarget = container || (() => { throw 'Invalid container supplied'; })() && false;

    // Unsupported browser - < IE8, feature-detect getElementsByClassName
    if (document.getElementsByClassName === undefined) {
        handleOutdatedBrowser(appendTarget);
        return false;
    }

    // React, ReactDOM, OMFECore and requested OMFEComponent
    const dependencies = [
        { src: !document.getElementById(`${Component}Style`) && `${distUrl}/${Component}.css?v=${buildVersion}` || 0, type: 'css', id: `${Component}Style` },
        { src: !window.React && `${distUrl}/React.js?v=${buildVersion}` || 0, type: 'js' },
        { src: !window.ReactDOM && `${distUrl}/ReactDOM.js?v=${buildVersion}` || 0, type: 'js' },
        { src: (!window.OMFE || !window.OMFE.OMFECore) && `${distUrl}/OMFECore.js?v=${buildVersion}` || 0, type: 'js' },
        { src: (!window.OMFE || !window.OMFE[Component]) && `${distUrl}/${Component}.js?v=${buildVersion}` || 0, type: 'js' },
    ];

    // Loads other components once rendered
    const loadOtherComponents = () => {
        if (!pendingLoad || !pendingLoad.length) {
            return false; // we're done
        }
        /* eslint no-shadow: 0 */
        const { OMFEComponent, container, props, children } = pendingLoad[0];
        pendingLoad = pendingLoad.slice(1);
        return load(OMFEComponent, container, props, children);
    };

    // Renders once done
    const loadComponent = () => {
        ReactDOM.unmountComponentAtNode(appendTarget);
        appendTarget.innerHTML = '';
        const newProps = props;
        newProps.store = newProps.store !== undefined && newProps.store || OMFE.OMFECore.store;
        ReactDOM.unmountComponentAtNode(appendTarget);
        ReactDOM.render(React.createElement(OMFE[Component].default, newProps, children), appendTarget);
        if (window && window.MutationObserver) {
            const observer = new MutationObserver(() => {
                if (appendTarget.parentNode === null) {
                    observer.disconnect();
                    ReactDOM.unmountComponentAtNode(appendTarget);
                }
            });
            observer.observe(appendTarget.parentNode, { childList: true });
        // state of the art polyfill
        } else {
            const interval = setInterval(() => {
                if (appendTarget.parentNode === null) {
                    clearInterval(interval);
                    ReactDOM.unmountComponentAtNode(appendTarget);
                }
            }, 1000);
        }
        isBusy = false;
        return loadOtherComponents();
    };

    // Recurses until all dependencies are loaded
    const d = document;
    let currentDependency = -1;
    const loadNextDependency = () => {
        currentDependency++;
        if (currentDependency >= dependencies.length) {
            loadComponent();
            return false;
        }
        const { src, type, id } = dependencies[currentDependency];
        if (!src || !src.length) {
            loadNextDependency();
            return false;
        }

        switch (type) {
            case 'js': {
                let scriptLoaded = false;
                const script = d.createElement('script');
                script.type = 'text/javascript';
                script.src = src;
                script.id = id || `l${Math.round((new Date()).getTime() + Math.random() * 1000001)}`;
                script.onload = () => {
                    if (!scriptLoaded) {
                        scriptLoaded = true;
                        loadNextDependency();
                    }
                    if (script.parentNode) {
                        script.parentNode.removeChild(script);
                    }
                };
                if (script.readyState !== undefined) {
                    script.onreadystatechange = () => {
                        if (!scriptLoaded && (!script.readyState || script.readyState === 'loaded' || script.readyState === 'complete')) {
                            scriptLoaded = true;
                            loadNextDependency();
                        }
                        if (script.parentNode) {
                            script.parentNode.removeChild(script);
                        }
                    };
                }
                appendTarget.appendChild(script);
                break;
            }
            case 'css': {
                let head = d.getElementsByTagName('head');
                head = head.length && head[0] || d.getElementsByTagName('body');
                head = head.parentNode && head || head.length && head[0] || appendTarget;

                const link = d.createElement('link');
                link.rel = 'stylesheet';
                link.media = 'all';
                link.type = 'text/css';
                link.href = src;
                link.id = id || `l${Math.round(Date.now() + Math.random() * 1000001)}`;
                const existingStyles = d.getElementsByTagName('link');
                if (existingStyles.length > 0) {
                    head.insertBefore(link, existingStyles[0]);
                } else {
                    head.appendChild(link);
                }
                loadNextDependency();
                break;
            }
            // ignores other extensions
            default: {
                loadNextDependency();
                break;
            }
        }
        return false;
    };

    // Start loading
    return loadNextDependency();
}


/**
 * loadPending - executes all functions under OMFE.ComponentLoaderReady
 */
export function loadPending() {
    if (!window || !window.OMFE || !window.OMFE.ComponentLoaderReady || !window.OMFE.ComponentLoaderReady.length) {
        return;
    }

    const pendingLoad = window.OMFE.ComponentLoaderReady;
    for (let i = 0; i < pendingLoad.length; i++) {
        if (pendingLoad[i]) {
            setTimeout(() => pendingLoad[i](window.OMFE));
        }
    }
    window.OMFE.ComponentLoaderReady = [];
}


/**
 * unload - unloads a loaded component, regardless of whether that component has finished loading or not
 */
export function unload() {
    throw new Error('Not implemented. Please remove component container instead');
}


/**
 * Execute loadPending() once this module is defined
 */
setTimeout(() => loadPending());



// WEBPACK FOOTER //
// ./src/ComponentLoader/ComponentLoader.js